module.exports = __webpack_public_path__ + "img/parentingImg.3cedb6b7.png";